import React, { Component } from "react";
import LogsListRow from "./LogsListRow";

class LogsList extends Component {
	render() {
		const { logs, scrollable } = this.props;

		let rows = null;
		if (logs) {
			rows = logs.map((log) => {
				return <LogsListRow key={log.Id} log={log} />;
			});
		}

		let style = {};
		if (scrollable) style = { display: "block", overflowY: "scroll", height: "500px" };

		return (
			<div>
				<table className="table table-striped" style={style}>
					<thead>
						<tr>
							<th className="col-md-2">Application name</th>
							<th className="col-md-1">Application version</th>
							<th className="col-md-2">Date</th>
							<th className="col-md-1">Domain</th>
							<th className="col-md-2">Used login</th>
							<th className="col-md-1">IP address</th>
							<th className="col-md-1">Success</th>
							<th className="col-md-2">Message</th>
						</tr>
					</thead>
					<tbody>{rows}</tbody>
				</table>
			</div>
		);
	}
}

export default LogsList;



// WEBPACK FOOTER //
// ./src/Components/LogsList/LogsList.js